export default "__VITE_PUBLIC_ASSET__26848af0__"